import { render, staticRenderFns } from "./DESTALT.vue?vue&type=template&id=1717bcb3&scoped=true&"
import script from "./DESTALT.vue?vue&type=script&lang=js&"
export * from "./DESTALT.vue?vue&type=script&lang=js&"
import style0 from "./DESTALT.vue?vue&type=style&index=0&id=1717bcb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1717bcb3",
  null
  
)

export default component.exports